export enum SmsProvider {
  PRELUDE = 'PRELUDE',
  SMS_HOSTING = 'SMS_HOSTING',
  NONE = 'NONE',
}
